<template>
  <div class="payment-container">
    <div class="majorTitle">
      Payment Methods
    </div>

    <div
      v-if="canViewPayments()"
      class="add-payment-container"
    >
      <button
        class="bidButton backgroundColorDefault"
        @click="() => { showCreditCardFormModal = true}"
      >
        Add Payment Method
      </button>
    </div>

    <div
      v-if="customer && customer.cc.length > 0"
      class="row"
      style="width: 100%"
    >
      <div
        v-for="card in customer.cc"
        :key="card.id"
        class="card-container"
      >
        <div class="card-info">
          <p>{{ card.type }}</p>
          <p>Ending in {{ String(card.last_four).padStart(4, '0') }}</p>
          <p>Expiration {{ card.expire_month }}/{{ card.expire_year }}</p>
        </div>
        <div
          v-if="canRemoveCard()"
          class="edit-card-container"
        >
          <button
            class="remove-btn"
            @click="removeCard(card.id)"
          >
            Remove
          </button>
        </div>
      </div>
    </div>

    <div
      v-if="showCreditCardFormModal"
      class="paddingNormalBottom"
    >
      <CreditCardFormModal
        :message="'Add a new card'"
        :card-values="Card"
        @updateCard="setCard"
        @confirm="addCard"
        @close="closeCreditCardFormModal"
      />
    </div>

    <LoadingOverlayComponent
      v-if="showLoading"
      :title="loadingTitle"
    />

    <AlertComponent
      v-if="showRegulatAlert"
      :title="regularAlertTitle"
      :message="regularAlertMessage"
      :secondary-action="null"
      @close="closeAlert()"
    />
  </div>
</template>

<script>
import LoadingOverlayComponent from '@/components/Shared/LoadingOverlayComponent.vue'
import AlertComponent from '@/components/Shared/AlertComponent.vue'
import apiMixin from '@/mixins/apiMixin.js'
import CreditCardFormModal from '@/components/Forms/CreditCardFormModal'

export default {
	name: 'PaymentMethodsComponent',
	components: {
		LoadingOverlayComponent,
		AlertComponent,
		CreditCardFormModal
	},
	mixins: [apiMixin],
	data () {
		return {
			loadingTitle: 'Gathering your account details',
			loadingSubTitle: '',
			showLoading: true,

			showRegulatAlert: false,
			regularAlertTitle: '',
			regularAlertMessage: '',

			showCreditCardFormModal: false,
			Card: {}
		}
	},

	computed: {
		customer: function () {
			return this.$store.getters.customer
		}
	},
	watch: {
		customer: function (customer) {
			if (customer.customer_id) {
				this.showLoading = false
			} else {
				this.showLoading = true
			}
		}
	},

	mounted () {

	},

	methods: {
		closeAlert: function () {
			this.showRegulatAlert = false
			this.loadingTitle = 'Gathering your account details'
			this.showLoading = true
			this.$store.dispatch('getAccount')
		},
		addCard: function () {
			this.showCreditCardFormModal = false
			this.showLoading = true
			this.$store.dispatch('getAccount')
		},
		setCard: function (cardValues) {

		},
		closeCreditCardFormModal: function () {
			this.showCreditCardFormModal = false
		},
		removeCard: function (cardId) {
			var cmp = this
			let apiPayload = {}
			apiPayload.apiEndpoint = 'account'
			apiPayload.postData = {}
			apiPayload.postData.action = 'delete_card'
			apiPayload.postData.card_id = cardId
			apiPayload.postData.customer_id = this.customer.customer_id

			this.loadingTitle = 'Deleting Card'
			this.showLoading = true
			cmp.$store.dispatch('apiCall', apiPayload).then(response => {
				this.showLoading = false
				if (response.data.result !== 'success') {
					this.regularAlertTitle = 'Error'
					this.regularAlertMessage = 'Your account could not be updated. If you have any questions, please contact us here: info@lelandlittle.com'
					this.showRegulatAlert = true
				} else {
					this.regularAlertTitle = 'Account Updated'
					this.regularAlertMessage = 'Your account has been updated.'
					this.showRegulatAlert = true
				}
			})
		},
		canViewPayments: function () {
			if (this.customer.international === true) {
				return false
			}

			return true
		},
		customerBlacklisted: function () {
			if (this.customer && this.customer.whiteblacklist !== 'blacklist') {
				return false
			}

			return true
		},
		canRemoveCard: function () {
			if (this.canViewPayments() === false) {
				return false
			}
			if (this.customerBlacklisted() === true) {
				return false
			}

			if (this.customer && this.customer.cc.length > 1) {
				return true
			} else {
				return false
			}
		},
		exit () {
			const referrer = localStorage.getItem('exit-referrer')
			if (referrer) {
				// If we have a exit-referrer, redirect to it
				window.location.replace(referrer)
				return
			}
			// Otherwise, redirect to the home page
			window.location.replace(this.getUrlHost(this.$store.getters.apiPath))
		}
	}
}
</script>

<style scoped>
    .payment-container {
        margin: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: 450px;
    }

    .add-payment-container {
        margin-bottom: 16px;
    }

    .card-container {
        display: flex;
        flex-direction: row;
        width: 100%;
        border: 1px solid lightgray;
        border-radius: 8px;
        padding: 16px;
        margin-bottom: 16px;
        background-color: rgba(100, 100, 100, .1);
    }

    .card-info {
        flex-basis: 50%;
    }

    .card-info p {
        margin-bottom: 0;
    }

    .edit-card-container {
        flex-basis: 50%;
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
    }

    .remove-btn {
        border: none;
        color: #000;
        margin-bottom: 0;
    }

    .bottom-buttons {
        margin-top: 16px;
    }

    #submitButton {
        background-color: #007AFF;
        color: white;
        border: 1px solid #007AFF;
        border-radius: 8px;
    }

    #exitButton {
        background-color: #ffffff;
        color: #333333;
        border-radius: 8px;
        margin: 0;
        margin-right: 40px;
        border: 1px solid rgba(51, 51, 51, 0.7);
    }
</style>
